import { useState } from "react"
import { TileSizeSelectors } from "web/components/Tiles"
import TileWizardActions from "web/components/AddTileWizard/TileWizardActions"

export default function TileGallerySettingsModal({
  backButtonHandler,
  close,
  overview,
  tileEntry,
}) {
  const [tileWidth, setTileWidth] = useState({
    value: tileEntry.width,
  })
  const [tileHeight, setTileHeight] = useState({
    value: tileEntry.height,
  })

  async function handleSave() {
    if (
      tileEntry.height !== tileHeight.value ||
      tileEntry.width !== tileWidth.value
    ) {
      await overview.update({
        [overview.type]: {
          tile_entries_attributes: [
            {
              id: tileEntry.id,
              height: tileHeight.value,
              width: tileWidth.value,
            },
          ],
        },
      })
    }

    close()
  }

  return (
    <>
      <div className="modal-content-above-commands">
        <div>
          <TileSizeSelectors
            tileWidth={tileWidth}
            tileHeight={tileHeight}
            setTileHeight={setTileHeight}
            setTileWidth={setTileWidth}
            limitTileSizeOptions={{ width: 2, height: 2 }}
          />
        </div>
      </div>
      <TileWizardActions
        onSaveHandler={handleSave}
        backButtonHandler={backButtonHandler}
      />
    </>
  )
}
